// Module
var code = "<left-menu params=\"items: items,\r\n                   label: label,\r\n                   selectedItem: selectedItem\"></left-menu> ";
// Exports
export default code;